module.exports = __webpack_public_path__ + "img/quiz_flavor_wrong_slash.63d1ddac.png";